import { render } from "./DeadLetters.vue?vue&type=template&id=09f73ec0&scoped=true"
import script from "./DeadLetters.vue?vue&type=script&lang=js"
export * from "./DeadLetters.vue?vue&type=script&lang=js"

import "./DeadLetters.vue?vue&type=style&index=0&id=09f73ec0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09f73ec0"]])

export default __exports__